module.exports = __webpack_public_path__ + "media/images/bsmart/icons/side_menu_home-ed593b1edf5698d470f2bc6696d38530.svg";